export default "__VITE_ASSET__DdRa0uhQ__"